import { addAsset } from '../../components/utilities';
import { FilteredItems } from './filteredItems';

export const FilterComponent = {
  root: document.querySelector('#component-products-filter-root'),
  filterContainer: document.querySelector('.filter-container'),
  filtersButton: document.querySelector('#open-filter-mobile'),
  settings: window.filterSettings || false,
  showPriceSlider: true,
  instance: false,

  sortArrayValues: function (array, property) {
    let sortedArray = array.sort((a, b) => {
      if (a[property] < b[property]) return -1;
      if (b[property] > b[property]) return 1;
      return 0;
    });

    // Define ordenação dos tamanhos
    const customOrder = ['xs', 'pp', 's', 'p', 'm', 'l', 'g', 'xl', 'gg', 'xxl', 'xg', 'xxxl', 'xgg'];
    sortedArray.forEach((item) => {
      item.sort = 99;
      customOrder.forEach((order, index) => {
        let itemValue = item[property].includes(',') ? item[property].split(',') : item[property];
        if (itemValue.length > 1) {
          itemValue = window.language != 'pt-BR' ? itemValue[1].trim() : itemValue[0].trim();
        }
        if (itemValue.toLowerCase() === order) item.sort = index;
      });
    });

    return sortedArray.sort((a, b) => {
      if (a.sort < b.sort) return -1;
      if (b.sort > b.sort) return 1;
      return 0;
    });
  },

  setTagTypes: function () {
    const { settings } = FilterComponent;
    const tags = [];

    if (settings.aggregations) {
      const aggregations = settings.aggregations;

      // Trecho legado: tipos das tags

      if (window.language != 'pt-BR') {

        // Filtro de Categorias
        if (aggregations.types.categoriaen)
          tags.push({
            title: 'Category',
            type: 'categoriaen',
            style: 'list',
            options: FilterComponent.sortArrayValues(
              aggregations.types.categoriaen,
              'title'
            ),
          });

        // Filtro de Salto
        if (aggregations.types.saltoen)
          tags.push({
            title: 'Heel',
            type: 'saltoen',
            style: 'list',
            options: FilterComponent.sortArrayValues(
              aggregations.types.saltoen,
              'title'
            ),
          });

        // Filtro de Altura
        if (aggregations.types.alturaen)
          tags.push({
            title: 'Height',
            type: 'alturaen',
            style: 'list',
            options: FilterComponent.sortArrayValues(
              aggregations.types.alturaen,
              'title'
            ),
          });

      } else {

        // Filtro de Categorias
        if (aggregations.types.categoria)
          tags.push({
            title: 'Categoria',
            type: 'categoria',
            style: 'list',
            options: FilterComponent.sortArrayValues(
              aggregations.types.categoria,
              'title'
            ),
          });

        // Filtro de Salto
        if (aggregations.types.salto)
          tags.push({
            title: 'Salto',
            type: 'salto',
            style: 'list',
            options: FilterComponent.sortArrayValues(
              aggregations.types.salto,
              'title'
            ),
          });

        // Filtro de Altura
        if (aggregations.types.altura)
          tags.push({
            title: 'Altura',
            type: 'altura',
            style: 'list',
            options: FilterComponent.sortArrayValues(
              aggregations.types.altura,
              'title'
            ),
          });

      }

    }

    return tags;
  },

  setPropeties: function () {
    const { settings } = FilterComponent;
    const properties = [];

    if (settings.aggregations) {
      const aggregations = settings.aggregations;

      const color_title = window.language != 'pt-BR' ? 'COLOR' : 'COR';
      const size_title = window.language != 'pt-BR' ? 'SIZE' : 'TAMANHO';

      // Filtros Atributo 1
      if (aggregations.properties.property1.length > 0)
        properties.push({
          title: color_title,
          property: 'property1',
          style: 'colors',
          colorsProps: {
            showTitle: true,
            showColor: true,
          },
          options: FilterComponent.sortArrayValues(
            aggregations.properties.property1,
            'value'
          ),
          patterns: settings.patterns,
        });

      // Filtros Atributo 2
      if (aggregations.properties.property2.length > 0)
        properties.push({
          title: size_title,
          property: 'property2',
          style: 'list',
          options: FilterComponent.sortArrayValues(
            aggregations.properties.property2,
            'value'
          ),
          patterns: settings.patterns,
        });
    }

    return properties;
  },

  setPricesRanges: function () {
    const { settings, showPriceSlider } = FilterComponent;
    let priceSettings = {
      price: false,
      priceProps: false,
    };

    // Exibe o slider de preço. Caso tenha faixas de preço,
    // preferência fica para as faixas (abaixo)
    if (showPriceSlider) {
      priceSettings.price = [
        settings.aggregations.min_price,
        settings.aggregations.max_price,
      ];
    }

    // Exibe as opções de faixa de preço
    if (settings.prices_range.length > 0) {
      priceSettings.priceProps = {
        mode: 'options',
        options: settings.prices_range,
      };
      priceSettings.price = [
        settings.aggregations.min_price,
        settings.aggregations.max_price,
      ];
    }

    return priceSettings;
  },

  setFilters: function () {
    const { root, settings } = FilterComponent;
    const tags = FilterComponent.setTagTypes();
    const properties = FilterComponent.setPropeties();
    const priceSettings = FilterComponent.setPricesRanges();
    const mode = 'horizontal';
    const hasSort = settings.has_sort || false;

    const componentFilters = new Vnda.Component.ProductsFilter({
      mode,
      hasSort: hasSort,
      filterOnClick: false,
      resetMode: 'all',
      tags,
      properties,
      price: window.language != 'pt-BR' ? false : priceSettings.price,
      priceProps: window.language != 'pt-BR' ? false : priceSettings.priceProps,
    });

    // Renderiza o componente
    componentFilters.render(root);
    FilterComponent.instance = componentFilters;
    root.dispatchEvent(new Event('vnda:filter-component-loaded'));
  },

  loadFilters: function () {
    const { settings } = FilterComponent;
    if (!settings) return;
    addAsset(settings.script, FilterComponent.setFilters);
    addAsset(settings.styles);
  },

  show: function () {
    const { root } = FilterComponent;

    if (!FilterComponent.instance) {
      FilterComponent.loadFilters();
      root.addEventListener('vnda:filter-component-loaded', () => {
        FilterComponent.instance.toggle();
      });
    } else {
      FilterComponent.instance.toggle();
    }
  },

  init: function () {
    const { root, filtersButton, handleSelectedFilters, filterContainer } = FilterComponent;
    if (!root) return;

    if (!window.mobile) {
      const eventType = window.mobile ? 'scroll' : 'mousemove';
        window.addEventListener(eventType, () => {
          FilterComponent.show();
        }, { once: true } );
    }

    filtersButton && filtersButton.addEventListener('click', () => {
      filtersButton.classList.toggle('-active', !filtersButton.classList.contains('-active'));
      console.log('root', root)
      root.classList.toggle('-open', !root.classList.contains('-open'));

      if (filterContainer) filterContainer.classList.toggle('-active', !filterContainer.classList.contains('-active'));

      if (window.mobile && root.classList.contains('-open') ) {
        FilterComponent.show();
      }

    });

    FilteredItems.init();

  },
};
